module.exports = __webpack_public_path__ + "static/media/noroute.c7446e65.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/noroute.jpg
// module id = 998
// module chunks = 0